module.exports = __webpack_public_path__ + "static/bugTracking-265d4fede7a551b20e6d87f295dace61.svg";